import { FoodsIcon } from "@foodpilot/foods";
import { Box, Button, CircularProgress, Stack, Typography, useTheme } from "@mui/material";
import { ExportSSQIconButton } from "../Button/ExportSSQIconButton";
import { useTranslation } from "react-i18next";
import { useQuestionnaireListContext } from "./context/useQuestionnaireList";
import { Link } from "react-router";

export const QuestionnaireListHeader = () => {
    const theme = useTheme();
    const { t } = useTranslation();

    const {
        ssqVersion,
        post,
        isSsqLoading,
        isPostLoading,
        ssqSsqHeadings,
        isLocked,
        canViewSsq,
        canValidateSsq,
        completeQuestionnaireUrl,
        questionnaireCompleteText,
        setLockPostModalOpen,
        title,
        exportSubject,
    } = useQuestionnaireListContext();

    const isLoading = isSsqLoading || isPostLoading;

    const firstHeadingUrl = ssqSsqHeadings.length > 0 ? completeQuestionnaireUrl(ssqSsqHeadings[0]) : "";
    return (
        <Stack
            flexDirection={{ xs: "column", lg: "row" }}
            justifyContent={"space-between"}
            alignItems={{ xs: "start", lg: "center" }}
            gap={{
                xs: theme.spacing(1),
                lg: theme.spacing(2),
            }}
        >
            <Stack flexDirection={"row"} gap={theme.spacing(1)} minWidth={"fit-content"}>
                <Typography variant="h2">{title}</Typography>
                <Box display={{ md: "block", lg: "none" }}>
                    {ssqVersion && post && (
                        <ExportSSQIconButton ssqVersion={ssqVersion} post={post} subject={exportSubject} />
                    )}
                </Box>
            </Stack>

            {!isLoading ?
                <Stack
                    flexDirection={{ sm: "column", md: "row" }}
                    gap={theme.spacing(1)}
                    width={"100%"}
                    justifyContent={"end"}
                    alignItems={{ sm: "start", md: "center" }}
                >
                    <Stack
                        display={{
                            xs: "none",
                            lg: "block",
                        }}
                    >
                        {ssqVersion && post && (
                            <ExportSSQIconButton ssqVersion={ssqVersion} post={post} subject={exportSubject} />
                        )}
                    </Stack>
                    <Stack flexDirection={"row"} gap={theme.spacing(1)} alignItems={"end"} justifyContent={"end"}>
                        {canValidateSsq !== false && (
                            <Button
                                onClick={() => {
                                    if (ssqVersion === undefined || post === undefined) return;

                                    setLockPostModalOpen(true);
                                }}
                                variant={isLocked ? "ternary" : "validate"}
                                color={isLocked ? "inherit" : "success"}
                                startIcon={
                                    isLocked ?
                                        <FoodsIcon size={2} icon={"edit"} />
                                    :   <FoodsIcon size={2} icon={"check"} />
                                }
                            >
                                {isLocked ?
                                    t("questionnaire.lock_button.unlock", "Modifier")
                                :   t("questionnaire.lock_button.lock", "Valider")}
                            </Button>
                        )}
                        {canViewSsq && (
                            <Link to={firstHeadingUrl}>
                                <Button
                                    variant="primary"
                                    endIcon={<FoodsIcon size={2} icon={"arrowRight"} />}
                                    disabled={firstHeadingUrl === ""}
                                >
                                    {questionnaireCompleteText}
                                </Button>
                            </Link>
                        )}
                    </Stack>
                </Stack>
            :   <CircularProgress />}
        </Stack>
    );
};
